// #=========== ---- =========== Import Angular Libraries =========== ---- ===========# //
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";

// #=========== ---- =========== Import Components =========== ---- ===========# //
import { MatSnackBar } from "@angular/material";

// #=========== ---- =========== Import Services =========== ---- ===========# //
import { AuthenticationService } from "../../../services/authentication.service";
import { CompanyService } from "src/app/services/company.service";

// #=========== ---- =========== Import Utils =========== ---- ===========# //
import { companyInputFields, getSelectedValues } from "../company-utils";

// #=========== ---- =========== Create Company Component Decorator =========== ---- ===========# //
@Component({
  selector: "app-create-company",
  templateUrl: "./create-company.component.html",
  styleUrls: ["./create-company.component.css"],
})

// #=========== ---- =========== Create Company Component =========== ---- ===========# //
export class CreateCompanyComponent implements OnInit {
    companyForm: FormGroup;

    leaveTypes: string[] = companyInputFields.leaveTypes;
    noDaysLeaveTypes: string[] = companyInputFields.noDaysLeaveTypes;
    customerTypes: string[] = companyInputFields.customerTypes;
    roles: string[] = companyInputFields.roles;
    modules: string[] = companyInputFields.modules;
    visitTypes: string[] = companyInputFields.visitTypes;
    doubleVisitTypes: string[] = companyInputFields.doubleVisitTypes;

    // #=========== ---- =========== Edit Company Component Constructor =========== ---- ===========# //
    constructor(
        private router: Router,
        private formBuilder: FormBuilder,
        private snackBar: MatSnackBar,
        private authenticationService: AuthenticationService,
        private companyService: CompanyService,
    ) {}

    // #=========== ---- =========== Edit Company Component ngOnInit =========== ---- ===========# //
    ngOnInit(): void {
        this.authenticationService.isLoggedInWithRedirect();

        this.companyForm = this.formBuilder.group({
            name: ["", Validators.required],
            senderName: ["", Validators.required],
            senderEmail: ["", [Validators.required, Validators.email]],
            leaveTypes: this.formBuilder.array([]),
            noDaysLeaveTypes: this.formBuilder.array([]),
            customerTypes: this.formBuilder.array([]),
            roles: this.formBuilder.array([]),
            modules: this.formBuilder.array([]),
            visitTypes: this.formBuilder.array([]),
            doubleVisitTypes: this.formBuilder.array([]),
        });

        this.populateFormArray("leaveTypes", this.leaveTypes);
        this.populateFormArray("noDaysLeaveTypes", this.noDaysLeaveTypes);
        this.populateFormArray("customerTypes", this.customerTypes);
        this.populateFormArray("roles", this.roles);
        this.populateFormArray("modules", this.modules);
        this.populateFormArray("visitTypes", this.visitTypes);
        this.populateFormArray("doubleVisitTypes", this.doubleVisitTypes);
    }

    // #=========== ---- =========== Edit Company Component Methods =========== ---- ===========# //
    
    // #=========== ---- =========== Populate Form Array =========== ---- ===========# //
    populateFormArray(formArrayName: string, allValues: string[]): void {
        const formArray = this.companyForm.get(formArrayName) as FormArray;
        allValues.forEach(value => { formArray.push(this.formBuilder.control(false)); });
    }

    // #=========== ---- =========== OnSubmit =========== ---- ===========# //
    onSubmit(): void {
        if (this.companyForm.invalid) {
            this.snackBar.open("Please fill in all required fields", "Close", {
                verticalPosition: "top",
                duration: 5000,
            });
            return;
        }

        let companyData = this.companyForm.value;

        companyData.leaveTypes = getSelectedValues(companyData.leaveTypes, this.leaveTypes);
        companyData.noDaysLeaveTypes = getSelectedValues(companyData.noDaysLeaveTypes, this.noDaysLeaveTypes);
        companyData.customerTypes = getSelectedValues(companyData.customerTypes, this.customerTypes);
        companyData.roles = getSelectedValues(companyData.roles, this.roles);
        companyData.modules = getSelectedValues(companyData.modules, this.modules);
        companyData.visitTypes = getSelectedValues(companyData.visitTypes, this.visitTypes);
        companyData.doubleVisitTypes = getSelectedValues(companyData.doubleVisitTypes, this.doubleVisitTypes);
        
        this.companyService.createCompany(companyData).subscribe(
            (res: any) => {
                if (res.message === "success") {
                    this.router.navigateByUrl("/companies");
                    this.snackBar.open("Company created successfully", "Close", {
                        verticalPosition: "top",
                        duration: 5000,
                    });
                } else {
                    this.snackBar.open("Company creation failed", "Close", {
                        verticalPosition: "top",
                        duration: 5000,
                    });

                    this.router.navigateByUrl("/companies");
                }
            }, (error) => {
                this.snackBar.open("Company creation failed", "Close", {
                    verticalPosition: "top",
                    duration: 5000,
                });

                this.router.navigateByUrl("/companies");
            }
        );
    }
}